export type WidgetContentSource = {
  disclaimerText?: string;
  suggestedQuestions?: string[];
};

export type ResolvedWidgetContent = {
  disclaimerText: string;
  suggestedQuestions: string[];
};

type ResolveWidgetContentOptions = {
  inline: WidgetContentSource;
  tenant: WidgetContentSource;
  defaultDisclaimerText: string;
};

const resolveRequiredText = (
  inlineValue: string | undefined,
  tenantValue: string | undefined,
  fallbackValue: string,
): string => {
  return inlineValue?.trim() || tenantValue?.trim() || fallbackValue;
};

export const resolvePlaceholder = (
  inlineValue: string | undefined,
  tenantValue: string | undefined,
  bundleDefault: string,
): string => {
  return inlineValue?.trim() || tenantValue?.trim() || bundleDefault;
};

export const resolveWidgetContent = ({
  inline,
  tenant,
  defaultDisclaimerText,
}: ResolveWidgetContentOptions): ResolvedWidgetContent => {
  return {
    disclaimerText: resolveRequiredText(
      inline.disclaimerText,
      tenant.disclaimerText,
      defaultDisclaimerText,
    ),
    suggestedQuestions:
      inline.suggestedQuestions ?? tenant.suggestedQuestions ?? [],
  };
};
